import { createSelector } from 'reselect'

import { emptyObj } from 'util/objects'

export function selectBase(state) {
  return state?.integrations?.thirdPartyData?.customProfile || emptyObj
}
export const selectCustomProfileContent = createSelector(
  selectBase,
  (state, { contactId }) => contactId,
  (base, contactId) => {
    return base[contactId]
  }
)
